import React, {Component} from 'react';
import './services.css';
import {IMAGE_URL} from "../constants";
import ReactHtmlParser from "react-html-parser";
import ServiceSlider from "../serviceSlider/ServiceSlider";

class Services extends Component {
    state = {
        pageData: this.props.pageData,
        serviceItemsPerPage: this.props.serviceItemsPerPage,
        lang: this.props.lang
    };

    componentWillReceiveProps(props) {
        let update = {};
        if(props.lang !== this.state.lang)
            update.lang = props.lang;
        if(props.serviceItemsPerPage !== this.state.serviceItemsPerPage)
            update.serviceItemsPerPage = props.serviceItemsPerPage;
        if(Object.keys(update).length > 0)
            this.setState({update});
    }

    render() {
        return <div className="services">
            {
                this.state.pageData.length > 0 &&
                <ServiceSlider
                    type="services"
                    lang={this.props.lang}
                    itemPerPage={this.state.serviceItemsPerPage}
                    data={this.state.pageData}
                />
            }
            </div>
    }
}
{/*<ServiceItem lang={this.state.lang} detail={this.state.pageData[0]}/>*/}
const ServiceItem = (props) => {
    return (<div className="servicesDetail">
                    <div className="servicesContent">
                        {props.lang === "tr" && <div className="servicesTitle">{ReactHtmlParser(props.detail.title_tr)}</div>}
                        {props.lang === "eng" && <div className="servicesTitle">{ReactHtmlParser(props.detail.title_eng)}</div>}

                        {props.lang === "tr" && <div className="servicesText">{ReactHtmlParser(props.detail.content_tr)}</div>}
                        {props.lang === "eng" && <div className="servicesText">{ReactHtmlParser(props.detail.content_eng)}</div>}
                </div>
                <div className="servicesImage">
                    <img alt="" src={IMAGE_URL + props.detail.image2}/>
                    <div className="servicesIndicator"></div>
                </div>
                <div className="servicesLogo">
                    <img alt="" src={IMAGE_URL + props.detail.image1}/>
                </div>
            </div>);
};

export default Services;